import { render, staticRenderFns } from "./AddLectureMarkDialog.vue?vue&type=template&id=8d39cede"
import script from "./AddLectureMarkDialog.vue?vue&type=script&lang=js"
export * from "./AddLectureMarkDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports